import { render, staticRenderFns } from "./BuildingView.vue?vue&type=template&id=5b440b18"
import script from "./BuildingView.vue?vue&type=script&lang=js"
export * from "./BuildingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports